import { handleError } from 'helper/rest';
import { client } from 'helper/axios';

export const getDealerAll = async ({ token, params }: any) => {
 try {
    return await client
       .get(`dealer_mapping`, {
          headers: {
             Authorization: `Bearer ${token}`,
          },
          params,
       })
       .then((response) => {
          return response;
       })
       .catch((error) => {
          const { response } = error;
          handleError(response);
          return response;
       });
 } catch (error) {
    console.error('error', error);
    return error;
 }
};

export const postRegisterDealer = async ({ token, params }: any) => {
 try {
    return await client
       .post(`dealer_mapping`, params, {
          headers: {
             Authorization: `Bearer ${token}`,
          },
       })
       .then((response) => {
          return response;
       })
       .catch((error) => {
          const { response } = error;
          handleError(response);
          return response;
       });
 } catch (error) {
    console.error('error', error);
    return error;
 }
};


export const getDealerMappingMyRegister = async ({ token, params }: any) => {
 try {
    return await client
       .get(`dealer_mapping_my_register`, {
          headers: {
             Authorization: `Bearer ${token}`,
          },
          params,
       })
       .then((response) => {
          return response;
       })
       .catch((error) => {
          const { response } = error;
          handleError(response);
          return response;
       });
 } catch (error) {
    console.error('error', error);
    return error;
 }
};


export const getDealerMappingMyIncome = async ({ token, params }: any) => {
 try {
    return await client
       .get(`dealer_mapping_my_income`, {
          headers: {
             Authorization: `Bearer ${token}`,
          },
          params,
       })
       .then((response) => {
          return response;
       })
       .catch((error) => {
          const { response } = error;
          handleError(response);
          return response;
       });
 } catch (error) {
    console.error('error', error);
    return error;
 }
};

export const updateMappingUpdateStatus = async ({ token, params }: any) => {
   try {
      return await client
         .post(`dealer_mapping_update_status`, params, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
  };
  
  export const postCreateDealerMappingPayrateUser = async ({ token, params }: any) => {
   try {
      return await client
         .post(`dealer_mapping_payrate`, params, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
  };

  export const postCreateDealerMappingPayrateGenerateUser = async ({ token, params }: any) => {
   try {
      return await client
         .post(`dealer_mapping_payrate_generate`, params, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
  };
  
  export const updateMappingGenerateKey = async ({ token, params }: any) => {
   try {
      return await client
         .post(`dealer_mapping_generate_key`, params, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
  };
  
  export const updateCreditsLimitDealer = async ({ token, params }: any) => {
   try {
      return await client
         .post(`dealer_mapping_update_max_credts_dealer`, params, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
  };

    
  export const updateCreditsDealer = async ({ token, params }: any) => {
   try {
      return await client
         .post(`dealer_mapping_update_credts_dealer`, params, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
  };

  
export const deleteMapping = async ({ token, id } : any) => {
   try {
      return await client
         .delete(`dealer_mapping_delete/${id}`, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};

